import React from "react";
import { BsGearFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import AppContext from "../context/AppProvider";
import { useContext } from "react";

const Header = () => {
  const navigate = useNavigate();
  const { settings, themes } = useContext(AppContext);
  const IconComponent = themes[settings.theme];

  const style = {
    width: "100%",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };
  const animalStyle = {
    width: "40%",
    height: "auto",
  };
  const gearStyle = {
    width: "5%",
    height: "5%",
    margin: "3%",
    padding: "0",
    marginTop: "0",
  };
  return (
    <div style={style}>
      <div
        style={{
          margin: "0",
          width: "100%",
          display: "flex",
          width: "100%",
          justifyContent: "flex-end",
        }}
      >
        <BsGearFill style={gearStyle} onClick={() => navigate("/settings")} />
      </div>
      <IconComponent style={animalStyle} />
      <h1 style={{ marginBottom: "0px" }}>Larissa's Habit Tracker</h1>
      <h4
        style={{ fontSize: "0.6rem", marginBottom: "15px", marginTop: "0px" }}
      >
        v2
      </h4>
    </div>
  );
};

export default Header;
